import Div from "@jumbo/shared/Div/Div";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import "./PreviewForms.css";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {axios_tenant} from "../../../../../axios";
import {del, get, patch, post, put} from "../../common/network";
import CreatingDraftModal from "../../components/common/modal-preview/CreatingDraftModal";
import FormReplaceModal from "../../components/common/modal-preview/FormReplaceModal";
import LastFormSaveModal from "../../components/common/modal-preview/LastFormSaveModal";
import ReadyForFilingModal from "../../components/common/modal-preview/ReadyForFilingModal";
import PdfFormPreview from "../../components/common/preview-form/PdfFormPreview";
import PreviewGeneratedFormsSelected from "../../components/common/preview-forms-selected/PreviewGeneratedFormsSelected";
import Form_ADS from "../../components/xfa-forms/Form_ADS";
import Form_SB_08 from "../../components/xfa-forms/Form_SB_08";
import Form_SB_16 from "../../components/xfa-forms/Form_SB_16";
import Form_SB_28 from "../../components/xfa-forms/Form_SB_28";
import Form_SB_30 from "../../components/xfa-forms/Form_SB_30";
import {applicantFormCodes, assigneeTenants, inventorFormCodes, tenant} from "../../constants";


const PreviewForms = () => {
    const location = useLocation();

    const [randomToRender, setRandomToRender] = useState(0);
    const [selectedMatter, setSelectedMatter] = useState("");
    const [selectedForm, setSelectedForm] = useState("");
    const [formData, setFormData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isPreviousFormData, setPreviousFormData] = useState(null);
    const [matterContacts, setMatterContacts] = useState([]);
    const [xfaCombinedData, setXfaCombinedData] = useState([]);
    const [replaceModalOpen, setReplaceModalOpen] = useState(null);
    const [readyForFilingOpen, setReadyForFilingOpen] = useState(false);
    const [confirmReplace, setConfirmReplace] = useState(false);
    const [confirmFiling, setConfirmFiling] = useState(false);
    const [upperSectionProps, setUpperSectionProps] = useState({});
    const [lowerSectionProps, setLowerSectionProps] = useState({});
    const [disabledFiling, setDisabledFiling] = useState(false);
    const [filingLoading, setFilingLoading] = useState(false);
    const [checkedForms, setCheckedForms] = useState({});
    const [currentFormData, setCurrentFormData] = useState(null);
    const [checkedDockets, setCheckedDockets] = useState({});
    const [saveFirstTime, setSaveFirstTime] = useState(true);
    const [creatingDraft, setCreatingDraft] = useState(true);
    const [discardLoading, setDiscardLoading] = useState(false);
    const [xfaResponseData, setXfaResponseData] = useState([]);
    const [lastFormSaveModalOpen, setLastFormSaveModalOpen] = useState(false);
    const [confirmRedirect, setConfirmRedirect] = useState(false);
    const isPreviousFormDataRef = useRef(isPreviousFormData);
    const [disableSaveNext, setDisableSaveNext] = useState(false);
    const [combinedData, setCombinedData] = useState(location.state?.combinedData || []);
    const [generatedFormData, setGeneratedFormData] = useState([]);
    const [correspondenceEmail, setCorrespondenceEmail] = useState(null);
    const [totalDrawingSheets, setTotalDrawingSheets] = useState(null);
    const matterList = location.state?.selectedRowsFromState || [];
    let formList = location.state?.selectedRows || [];
    let xfaCombinedArray = combinedData?.filter(data => {
        if (formList.find(form => form.id === data.form_id)?.isXfa) {
            return true;
        }
    });

    let nonXfaCombinedData = combinedData.filter(data => {
        return !xfaCombinedArray.includes(data);
    });

    useEffect(() => {
        setXfaCombinedData(xfaCombinedArray);
    }, []);

    useEffect(() => {
        setSelectedMatter(matterList[0]?.id);
        setCorrespondenceEmail(matterList[0]?.correspondence_email);
        setTotalDrawingSheets(matterList[0]?.total_drawing_sheets);
    }, [matterList]);

    useEffect(() => {
        if (confirmRedirect) {
            navigate("/docgen/drafts");
        }
    }, [confirmRedirect]);

    useEffect(() => {
        const loadData = async () => {
            try {
                setSelectedForm(formList[0].id);
                const nonXfaFormIndex = formList.findIndex(form => !form.isXfa);
                if (nonXfaFormIndex !== -1) {
                    const loadInitialData = await fetchNewFormData(formList[nonXfaFormIndex].id, matterList[0]?.id);
                    setFormData(loadInitialData);
                }
                setConfirmReplace(null);
            } catch (error) {
                setCreatingDraft(false);
            }
        };

        loadData();
    }, []);

    const fetchData = async () => {
        try {
            const response = selectedMatter && (await get(`docgen/matters/${selectedMatter}`));
            let matterData = response?.data?.matter_parties || [];
            const currentMatter = matterList.find(matter => matter.id === selectedMatter);
            const attorneyName = currentMatter?.attorney_name;
            const referenceNo = currentMatter?.reference_no;
            if( attorneyName ){
                const attorneys = matterData.filter(p => p?.party_type === "Attorney");
                const others = matterData.filter(p => p?.party_type !== "Attorney");
                const idx = attorneys.findIndex(mp => mp?.party?.name === attorneyName);
                if (idx !== -1) {
                    const [selectedAttorney] = attorneys.splice(idx, 1);
                    selectedAttorney.sequence_no = 1;
                    selectedAttorney.party.reference_no = referenceNo || selectedAttorney.party.reference_no || "";
                    let seq = 2;
                    const updatedAttorneys = [
                    selectedAttorney,
                    ...attorneys.map(a => ({
                        ...a,
                        sequence_no: seq++,
                    })),
                    ];
                    matterData = [...updatedAttorneys, ...others];
                }
            }
            setMatterContacts(matterData);
        } catch (error) {
        }
    };

    const fetchExistingFormData = async (selectedForm, selectedMatter, status, fetchAll) => {
        if (selectedForm && selectedMatter) {
            let response = await get(`docgen/check-existing-generated-forms`, {
                params: {
                    formId: selectedForm,
                    matterId: selectedMatter,
                    status: status,
                    fetchAll: fetchAll
                }
            });

            if (upperSectionProps?.selectedItems?.[selectedMatter]?.find(form => form.id === selectedForm)?.isXfa) {
                const generatedFormId = xfaResponseData?.find((data) => (data.form_id === selectedForm) && (data.matter_id === selectedMatter))?.generated_id;
                if (generatedFormId) {
                    let xfaResponse = await get(`docgen/forms/generate/${generatedFormId}/data`);
                    if (xfaResponse) {
                        setXfaCombinedData(prevData => prevData.map((item) => {
                            if ((item.form_id === selectedForm) && (item.matter_id === selectedMatter)) {
                                return {...item, data: xfaResponse};
                            }
                            return item;
                        }));
                    }
                }
            }
            return response;
        }
    };

    const fetchNewFormData = async (selectedForm, selectedMatter) => {
        if (selectedForm && selectedMatter) {
            const currentMatter = matterList.find(matter => matter.id === selectedMatter);
            return await post(`docgen/generated-forms`, {
                matter_id: selectedMatter,
                form_id: selectedForm,
                attorney_name: currentMatter?.attorney_name,
                reference_no: currentMatter?.reference_no,
            });
        }
    };

    useEffect(() => {
        isPreviousFormDataRef.current = isPreviousFormData;
        if (!isPreviousFormData) {
            setDisableSaveNext(true);
        } else {
            setDisableSaveNext(false);
        }
    }, [isPreviousFormData]);

    useEffect(() => {
        fetchData();

        setConfirmReplace(null);
        if (upperSectionProps?.selectedItems?.[selectedMatter]?.length > 0) {
            if (selectedForm === upperSectionProps?.selectedItems?.[selectedMatter]?.[0]?.id) {
                setRandomToRender(Math.random());
            } else {
                setSelectedForm(upperSectionProps?.selectedItems?.[selectedMatter]?.[0]?.id);
            }
        }
    }, [selectedMatter]);

    useEffect(() => {
        setConfirmReplace(null);

        if (selectedForm && selectedMatter && !saveFirstTime) {
            const loadForms = async () => {
                try {
                        setPreviousFormData(null);
                        setIsLoading(true);
                        const response = await fetchExistingFormData(selectedForm, selectedMatter, "Draft");
                        if (!upperSectionProps?.selectedItems?.[selectedMatter]?.find(form => form.id === selectedForm)?.isXfa) {
                            if (response?.data) {
                                setFormData(response);
                            }
                        }
                        setIsLoading(false);
                } catch (error) {
                    setCreatingDraft(false);
                }
            };

            loadForms();
        }
    }, [selectedForm, randomToRender]);

    useEffect(() => {
        const saveAllForms = async () => {
            if (!formList.find(form => form.id === selectedForm)?.isXfa) {
                const loadInitialData = await fetchNewFormData(selectedForm, selectedMatter);
                setFormData(loadInitialData);
            }
        };
       
        if(selectedForm && selectedMatter && (currentFormData || formList.find(form => form.id === selectedForm)?.isXfa) && saveFirstTime){
            const saveForms = async () => {
                setCreatingDraft(true);
                await saveAllForms();
                await saveAsDraftAll();
                setSaveFirstTime(false);
            }
            saveForms();
        }
    }, [selectedForm, currentFormData]);

    const navigate = useNavigate();

    const onSaveAndNext = async () => {
        const matterList = upperSectionProps?.selectedDockets;
        const formList = upperSectionProps?.selectedItems?.[selectedMatter];

        if (formList.find(form => form.id === selectedForm)?.isXfa) {
            const selectedXfa = xfaCombinedData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);

            if (selectedXfa) {
                const generatedFormId = xfaResponseData?.find((data) => (data.form_id === selectedXfa.form_id) && (data.matter_id === selectedXfa.matter_id))?.generated_id;
                const matter = matterList.find(matter => matter.id === selectedXfa.matter_id);
                const requestBody = {
                    formId: generatedFormId,
                    status: "Draft",
                    attorneyName: matter?.attorney_name,
                    referenceNo: matter?.reference_no,
                    data: selectedXfa.matter_records ? {
                        signatories: selectedXfa.matter_records?.map(p => ({name: p.name, referenceNo: p.referenceNo})) || []
                    } : {...selectedXfa.data}
                };

                try {
                    setIsLoading(true);
                    const response = await patch(`/docgen/forms/generate`, requestBody);
                    if (!response.statusCode) {
                        toast.success("Form generated successfully");
                    }
                } catch (error) {

                } finally {
                    setIsLoading(false);
                }
            } else {
                toast.error("No form or docket selected");
            }
        } else if (currentFormData) {
                setIsLoading(true);
                const sendResponse = async () => {
                    try {
                        const matter = matterList.find(matter => matter.id === selectedMatter);
                        const response = await put(`/docgen/generated-forms`, {
                            form_id: selectedForm,
                            matter_id: selectedMatter,
                            data: currentFormData,
                            changedData: currentFormData,
                            previousData: isPreviousFormData,
                            status: "Draft",
                            attorneyName: matter?.attorney_name,
                            referenceNo: matter?.reference_no,
                        });
                        setIsLoading(false);
                        if (response?.success === true) {
                            // Check if the pair exists in the combinedData array
                            const existingPairIndex = nonXfaCombinedData.findIndex(pair => pair.matter_id === selectedMatter && pair.form_id === selectedForm);

                            if (existingPairIndex !== -1) {
                                // Update the existing pair with generated_form_id, currentFormData, and status
                                nonXfaCombinedData[existingPairIndex].generatedformid = response.data.id;
                                nonXfaCombinedData[existingPairIndex].changedData = currentFormData;
                                nonXfaCombinedData[existingPairIndex].previousData = isPreviousFormData;
                                nonXfaCombinedData[existingPairIndex].status = "Draft";
                            }

                            const formCode = upperSectionProps?.selectedItems?.[selectedMatter]?.find(item => item.id === selectedForm)?.form_code;
                            if (inventorFormCodes.includes(formCode)) {
                                const inventorList = matterContacts?.filter(contact => contact?.party_type === "Inventor")?.map(contact => contact?.party?.name);
                                if (inventorList?.length > 0) {
                                    const message = `Form has been separately saved for the following inventors : ${inventorList.join(",")}`;
                                    toast.success(message);
                                }
                            } else if (applicantFormCodes.includes(formCode)) {
                                const applicantList = matterContacts?.filter(contact => contact?.party_type === (assigneeTenants.has(tenant) ? "Assignee" : "Applicant"))?.map(contact => contact?.party?.name);
                                if (applicantList?.length > 0) {
                                    const message = `Form has been separately saved for the following applicants : ${applicantList.join(",")}`;
                                    toast.success(message);
                                }
                            } else {
                                toast.success(response.message);
                            }

                        }
                    } catch (error) {
                    } finally {
                        setIsLoading(false);
                    }
                };
                await sendResponse();
            }

        const currentMatterIndex = matterList.findIndex(item => item.id === selectedMatter);
        const currentFormIndex = formList.findIndex(item => item.id === selectedForm);
        let nextMatterIndex, nextFormIndex;
        if (currentMatterIndex === -1 && matterList.length) nextMatterIndex = 0;

        if (currentFormIndex === -1 && formList.length) nextFormIndex = 0;

        if (nextFormIndex === undefined && nextMatterIndex === undefined) {
            nextFormIndex = (currentFormIndex + 1) % formList.length;
            nextMatterIndex = nextFormIndex ? currentMatterIndex : (currentMatterIndex + 1);
            if (nextMatterIndex === matterList.length) {
                setLastFormSaveModalOpen(true);
                const response = await fetchExistingFormData(selectedForm, selectedMatter, "Draft");
                if (!upperSectionProps?.selectedItems?.[selectedMatter]?.find(form => form.id === selectedForm)?.isXfa) {
                    if (response?.data) {
                        setFormData(response);
                    }
                }
            }
        }

        if (nextMatterIndex !== matterList.length) {
            setUpperSectionProps((prevState) => ({...prevState, selectedDocket: matterList[nextMatterIndex]?.id}));
            setUpperSectionProps((prevState) => ({...prevState, selectedForm: formList[nextFormIndex]?.id}));
            setSelectedMatter(matterList[nextMatterIndex]?.id);
            setCorrespondenceEmail(matterList[nextMatterIndex]?.correspondence_email);
            setTotalDrawingSheets(matterList[nextMatterIndex]?.total_drawing_sheets);
            setSelectedForm(formList[nextFormIndex]?.id);
        }
    };

    const backHandler = () => {
        const matterList = upperSectionProps?.selectedDockets;
        const formList = upperSectionProps?.selectedItems?.[selectedMatter];

        const currentMatterIndex = matterList.findIndex(item => item.id === selectedMatter);
        const currentFormIndex = formList.findIndex(item => item.id === selectedForm);

        if (currentMatterIndex !== -1) {
            const previousMatterIndex = currentMatterIndex - 1;
            const nextMatterIndex = previousMatterIndex < 0 ? matterList.length - 1 : previousMatterIndex;

            if (currentFormIndex !== -1) {
                const previousFormIndex = currentFormIndex - 1;
                const nextFormIndex = previousFormIndex < 0 ? formList.length - 1 : previousFormIndex;

                setSelectedForm(formList[nextFormIndex]?.id);
                setUpperSectionProps((prevState) => ({...prevState, selectedForm: formList[nextFormIndex]?.id}));

                if (nextFormIndex === formList.length - 1) {
                    setSelectedMatter(matterList[nextMatterIndex]?.id);
                    setCorrespondenceEmail(matterList[nextMatterIndex]?.correspondence_email);
                    setTotalDrawingSheets(matterList[nextMatterIndex]?.total_drawing_sheets);
                    setUpperSectionProps((prevState) => ({...prevState, selectedDocket: matterList[nextMatterIndex]?.id}));
                }
            } else if (formList.length > 0) {
                setSelectedForm(formList[formList.length - 1].id); // Go to the last form
                setUpperSectionProps((prevState) => ({...prevState, selectedForm: formList[formList.length - 1]?.id}));
                setSelectedMatter(matterList[nextMatterIndex].id);
                setCorrespondenceEmail(matterList[nextMatterIndex]?.correspondence_email);
                setTotalDrawingSheets(matterList[nextMatterIndex]?.total_drawing_sheets);
                setUpperSectionProps((prevState) => ({...prevState, selectedDocket: matterList[nextMatterIndex]?.id}));
            } else {
                setSelectedMatter(matterList[nextMatterIndex].id); // Go to the previous matter
                setCorrespondenceEmail(matterList[nextMatterIndex]?.correspondence_email);
                setTotalDrawingSheets(matterList[nextMatterIndex]?.total_drawing_sheets);
                setUpperSectionProps((prevState) => ({...prevState, selectedDocket: matterList[nextMatterIndex]?.id}));
            }
        } else if (matterList.length > 0) {
            setSelectedMatter(matterList[matterList.length - 1].id); // Go to the last matter
            setCorrespondenceEmail(matterList[nextMatterIndex]?.correspondence_email);
            setTotalDrawingSheets(matterList[nextMatterIndex]?.total_drawing_sheets);
            setUpperSectionProps((prevState) => ({...prevState, selectedDocket: matterList[matterList.length - 1].id}));
        }
    };

    const completeAll = async (filingParameters) => {

        let errorExists = false;
        const filterForms = (item) => {
            const response = filingParameters.find((parameter) => parameter.matter_id === String(item.matter_id) && parameter.form_id === String(item.form_id));
            if (response) {
                return true;
            }
        };

        const completeXfa = async () => {
            await Promise.all(
                xfaCombinedData?.filter((item) => filterForms(item))?.map(async xfaData => {
                    const generatedFormId = xfaResponseData?.find((data) => (data.form_id === xfaData.form_id) && (data.matter_id === xfaData.matter_id))?.generated_id;
                    const requestBody = {
                        formId: generatedFormId,
                        status: "Completed",
                        data: xfaData?.matter_records ? {
                            signatories: xfaData.matter_records?.map(p => ({name: p.name, referenceNo: p.referenceNo})) || []
                        } : {...xfaData.data}
                    };

                    try {
                        const response = await patch(`/docgen/forms/generate`, requestBody);
                        if (response?.statusCode === 500 || response?.statusCode === 404 || response?.statusCode === 400 || response?.statusCode === 504) {
                            errorExists = true;
                        }
                    } catch (error) {
                        errorExists = true;
                    }
                })
            );
        };

        const completeNonXfa = async () => {
            const selectedDocketFormList = filingParameters?.filter(item => item.matter_id === String(selectedMatter))?.map(item => item.form_id);
            const nonXfaFormIndex = upperSectionProps?.selectedItems?.[selectedMatter]?.findIndex(form => !form?.isXfa && selectedDocketFormList.includes(String(form.id)));

            let selectedFormId;
            if (upperSectionProps?.selectedItems?.[selectedMatter]?.find(item => item.id === selectedForm)?.isXfa) {
                selectedFormId = upperSectionProps?.selectedItems?.[selectedMatter]?.[nonXfaFormIndex]?.id;
            } else {
                selectedFormId = selectedForm;
                if (nonXfaCombinedData.length > 0) {

                    if (currentFormData) {
                        const existingPairIndex = nonXfaCombinedData?.findIndex(pair => pair.matter_id === selectedMatter && pair.form_id === selectedFormId);

                        if (existingPairIndex !== -1) {
                            // Update the existing pair with currentFormData, and status
                            nonXfaCombinedData[existingPairIndex].previousData = isPreviousFormData;
                            nonXfaCombinedData[existingPairIndex].changedData = currentFormData;
                            nonXfaCombinedData[existingPairIndex].status = "Completed";
                        } else {
                            // Add the new pair to the combinedData array
                            nonXfaCombinedData.push({
                                matter_id: selectedMatter,
                                form_id: selectedFormId,
                                changedData: currentFormData,
                                status: "Completed",
                                previousData: isPreviousFormData
                            });
                        }
                    }
                }
            }

            // Update the status of all objects in the combinedData array to "Completed"
            let updatedCombinedData = nonXfaCombinedData?.filter((item) => filterForms(item))?.map(pair => ({
                ...pair,
                status: "Completed"
            }));

            if (generatedFormData?.length) {
                const output = generatedFormData.map(generatedItem => {
                    // Find the corresponding item in updatedCombinedData
                    const matchingItem = updatedCombinedData.find(
                        updatedItem =>
                            updatedItem.matter_id === generatedItem.matter_id &&
                            updatedItem.form_id === generatedItem.form_id
                    );

                    // If a match is found, create a new object with updated data
                    if (matchingItem) {
                        return {
                            ...matchingItem,
                            generatedformid: generatedItem.generated_form_id
                        };
                    }
                    return null;
                }).filter(item => item !== null);
                updatedCombinedData = output;
            }
            updatedCombinedData.forEach(obj => {
                delete obj["form_id"];
            });

            const sendResponse = async () => {
                const response = await put(`/docgen/all-generated-forms`, {
                    data: updatedCombinedData
                });

                if (response?.success === true) {
                    if (response?.error?.length > 0) {
                        errorExists = true;
                        response.error.forEach(e => toast.error(e));
                    }
                } else {
                    errorExists = true;
                    throw response?.error?.message || response?.error;
                }
            };

            await sendResponse();
        };

        Promise.all([completeXfa(), completeNonXfa()])
               .then(() => {
                   setFilingLoading(false);
                   if (!errorExists) {
                       toast.success("All selected form(s) marked as complete");
                       setUpperSectionProps((prevState) => {
                           const newState = {...prevState};
                           for (const param of filingParameters) {
                               newState.selectedItems[param.matter_id] = newState.selectedItems?.[param.matter_id]?.filter(item => param.form_id !== String(item.id));
                           }
                           return newState;
                       });
                       setCheckedDockets({});
                       setCheckedForms({});

                   }
               })
               .catch(() => {
                   setFilingLoading(false);
               });
    };

    const saveAsDraftAll = async () => {
        let errorExists = false;
        let responseData = [];
        
        const saveDraftXfa = async () => {
            await Promise.all(
                xfaCombinedData?.map(async xfaData => {
                    const matter = matterList.find(matter => matter.id === xfaData.matter_id);
                    const requestBody = {
                        formId: xfaData.form_id,
                        matterId: xfaData.matter_id,
                        status: "Draft",
                        attorneyName: matter?.attorney_name,
                        referenceNo: matter?.reference_no,
                        data: xfaData?.matter_records ? {
                            signatories: xfaData.matter_records?.map(p => ({name: p.name, first_name: p.first_name, middle_name: p.middle_name, last_name: p.last_name, referenceNo: p.referenceNo})) || []
                        } : {...xfaData.data}
                    };

                    try {
                        const response = await post(`/docgen/forms/generate`, requestBody);
                        if (response?.statusCode === 500 || response?.statusCode === 404 || response?.statusCode === 400 || response?.statusCode === 504) {
                            errorExists = true;
                        }
                        setXfaResponseData((prevData) => ([...prevData, {
                            generated_id: response?.id,
                            form_id: response?.form_id,
                            matter_id: response?.matter_id
                        }]));
                        responseData = [...responseData, {form_id: response?.form_id, matter_id: response?.matter_id}];
                    } catch (error) {
                        errorExists = true;
                    }
                })
            );
        };

        const saveDraftNonXfa = async () => {
            
            try {
                if (nonXfaCombinedData.length > 0) {
                    // Check if the pair exists in the combinedData array
                    const existingPairIndex = nonXfaCombinedData?.findIndex(pair => pair.matter_id === selectedMatter && pair.form_id === selectedForm);

                    if (existingPairIndex !== -1 && currentFormData) {
                        // Update the existing pair with currentFormData, and status
                        nonXfaCombinedData[existingPairIndex].previousData = null;
                        nonXfaCombinedData[existingPairIndex].changedData = currentFormData;
                        nonXfaCombinedData[existingPairIndex].status = "Draft";
                    }
                    const matterMap = new Map(matterList.map(m => [m.id, m]));
                    const updatedCombinedData = nonXfaCombinedData?.map(nonXfa => {
                        const matter = matterMap.get(nonXfa.matter_id) || {};
                        return {
                            ...nonXfa,
                            status: "Draft",
                            attorney_name: matter.attorney_name,
                            reference_no: matter.reference_no,
                        };
                    });

                    

                    const sendResponse = async () => {
                        const response = await put(`/docgen/all-generated-forms`, {
                            data: updatedCombinedData
                        });

                        

                        const genCombinedData = combinedData.map(item => {
                            const match = response?.data?.find(dataItem => dataItem.matter_id === item.matter_id && dataItem.form_id === item.form_id);
                            if (match?.generatedformid) {
                                return item;
                            }
                            if (match) {
                                return {
                                    ...item,
                                    generatedformid: match.generated_form_id
                                };
                            }
                            return item;
                        });
                        setGeneratedFormData(response?.data);
                        setCombinedData(genCombinedData);

                        if (response?.success === true) {
                            responseData = [...responseData, ...response?.data];
                            if (response?.error?.length > 0) {
                                errorExists = true;
                                response.error.forEach((e) => {
                                    toast.error(e);
                                });
                            }
                        } else {
                            errorExists = true;
                            throw response?.error?.message || response?.error;
                        }
                    };
                    await sendResponse();
                }
            } catch (error) {
                throw error;
            }
        };


        Promise.all([saveDraftXfa(), saveDraftNonXfa()])
               .then(() => {
                   setCreatingDraft(false);
                   let groupedResponseData = {};

                   responseData.forEach(({matter_id, form_id}) => {
                       if (!groupedResponseData[matter_id]) {
                           groupedResponseData[matter_id] = new Set();
                       }
                       groupedResponseData[matter_id].add(form_id);
                   });
                   setUpperSectionProps((prevState) => {
                       const newState = {...prevState};
                       Object.keys(newState.selectedItems).forEach(matterId => {
                           if (groupedResponseData[matterId]) {
                               newState.selectedItems[matterId] = newState.selectedItems[matterId].filter(form =>
                                   groupedResponseData[matterId].has(form.id)
                               );
                           } else {
                               newState.selectedItems[matterId] = [];
                           }
                       });
                       return newState;
                   });
               })
               .catch((error) => {
                   setCreatingDraft(false);
               });
    };

    const handleFiling = async () => {
        try {
            setFilingLoading(true);

            let filingParameters = [];
            for (const matterId of Object.keys(checkedDockets)?.filter(item => checkedDockets[item])) {
                for (const formId of Object.keys(checkedForms?.[matterId] || {})?.filter(item => checkedForms?.[matterId]?.[item])) {
                    const response = await fetchExistingFormData(formId, matterId, "Completed");

                    const formCode = formList.find((form) => String(form.id) === formId)?.form_code;
                    const matterName = matterList.find((form) => String(form.id) === matterId)?.host_file_number;
                    if (response.data) {
                        setReplaceModalOpen(true);

                        const userConfirmed = await new Promise((resolve) => {
                            const handleConfirm = () => {
                                setReplaceModalOpen(false);
                                resolve(true);
                            };

                            const handleCancel = () => {
                                setReplaceModalOpen(false);
                                resolve(false);
                            };

                            setReplaceModalOpen({onConfirm: handleConfirm, onCancel: handleCancel, matterName: matterName, formCode: formCode});
                        });

                        if (userConfirmed) {
                            filingParameters.push({matter_id: matterId, form_id: formId});
                        } else {
                            setUpperSectionProps(prevState => {
                                const newState = {...prevState};
                                newState.selectedItems[matterId] = newState?.selectedItems?.[matterId]?.filter(item => String(item.id) !== formId);
                                return newState;
                            });
                        }
                        setConfirmReplace(null);
                        setReplaceModalOpen(false);
                    } else {
                        filingParameters.push({matter_id: matterId, form_id: formId});
                    }
                }
            }

            if (filingParameters.length > 0) {
                const checkAndFile = async () => {
                    if (!upperSectionProps?.selectedItems?.[selectedMatter]?.find(form => form.id === selectedForm)?.isXfa) {
                        const viewer = document.getElementById("preview-form-container")?.ej2_instances[0];

                        if (viewer && viewer.isRendered) {
                            await completeAll(filingParameters);
                        } else {
                            setTimeout(checkAndFile, 1000);
                        }
                    } else {
                        await completeAll(filingParameters);
                    }
                };
                await checkAndFile();
            } else {
                setCheckedDockets({});
                setCheckedForms({});
                setFilingLoading(false);
            }
        } catch (error) {
        }
    };

    useEffect(() => {
        const uncheckedDockets = Object.keys(checkedDockets)?.every((key) => checkedDockets[key] === false);
        const uncheckedForms = Object.keys(checkedForms?.[selectedMatter] || {})?.every((key) => checkedForms?.[selectedMatter]?.[key] === false);
        if (!uncheckedDockets && !uncheckedForms) {
            setDisabledFiling(false);
        } else {
            setDisabledFiling(true);
        }
    }, [checkedDockets, checkedForms]);

    let formComponent;
    const formCode = formList.find(form => form.id === selectedForm)?.form_code;
    switch (formCode) {
        case "SB-28":
            formComponent =
                <Form_SB_28 matterContacts={matterContacts} selectedMatter={selectedMatter} selectedForm={selectedForm}
                            xfaCombinedData={xfaCombinedData} setXfaCombinedData={setXfaCombinedData}/>;
            break;
        case "AIA-14":
            formComponent =
                <Form_ADS matterContacts={matterContacts} selectedMatter={selectedMatter} selectedForm={selectedForm}
                          xfaCombinedData={xfaCombinedData} setXfaCombinedData={setXfaCombinedData} correspondenceEmail={correspondenceEmail} totalDrawingSheets={totalDrawingSheets}/>;
            break;

        case "SB-08":

            formComponent =
                <Form_SB_08 matterContacts={matterContacts} selectedMatter={selectedMatter} selectedForm={selectedForm}
                            xfaCombinedData={xfaCombinedData} setXfaCombinedData={setXfaCombinedData}/>;
            break;

        case "SB-16":
            formComponent =
                <Form_SB_16 matterContacts={matterContacts} selectedMatter={selectedMatter} selectedForm={selectedForm}
                            xfaCombinedData={xfaCombinedData} setXfaCombinedData={setXfaCombinedData}/>;
            break;

        case "SB-30":
            formComponent =
                <Form_SB_30 matterContacts={matterContacts} selectedMatter={selectedMatter} selectedForm={selectedForm}
                            xfaCombinedData={xfaCombinedData} setXfaCombinedData={setXfaCombinedData}/>;
            break;

        default:
            formComponent = null;
    }

    const handleDiscard = async () => {
        setDiscardLoading(true);
        let selectedIds = [];
        try {
            for (const matterId of Object.keys(upperSectionProps?.selectedItems)) {
                for (const form of upperSectionProps?.selectedItems?.[matterId]) {
                    const response = await fetchExistingFormData(form.id, matterId, "Draft");
                    if (response?.data) {
                        const {data} = await axios_tenant.get("/docgen/v1/forms", {
                            params: {
                                formId: form.id,
                                matterId
                            }
                        });
                        selectedIds = [...selectedIds, ...data.map(({id}) => id)];
                    }
                }
            }

            if (selectedIds.length > 0) {
                const response = await del(`docgen/generate-forms`, {
                    formIds: selectedIds
                });

                if (response?.success === true) {
                    setCheckedDockets({});
                    setCheckedForms({});
                    toast.success(response.message);
                    navigate("/docgen/drafts");
                }
            } else {
                toast.error("File cannot be deleted as it has been already completed or not present");
            }
        } catch (error) {
        } finally {
            setDiscardLoading(false);
        }
    };

    return (
        <div className="page-content-wrapper">
            <Box className="w-100">
                <header className="section-heading">
                    <Box flexGrow={1}/>
                    <Box sx={{display: "flex", flexDirection: "row"}}>
                        {discardLoading ? <CircularProgress sx={{color: "blue"}}/> :
                            <Button
                                type="button"
                                variant="outlined"
                                color="error"
                                onClick={handleDiscard}
                                sx={{
                                    borderWidth: "2px !important"
                                }}
                                disabled={filingLoading}
                            >
                                Discard
                            </Button>}

                        {/*{filingLoading ? (<CircularProgress sx={{color: "blue", marginLeft: "5%"}}/>) : (
                            <Button
                                type="button"
                                className="ms-2"
                                onClick={handleFiling}
                                sx={{
                                    backgroundColor: "#6666b6 !important",
                                    color: "#fff !important",
                                    "&:hover": {
                                        backgroundColor: "#5d5d9a !important"
                                    },
                                    "&:disabled": {
                                        backgroundColor: "#EBE4D1 !important"
                                    }
                                }}
                                disabled={isLoading || disabledFiling || filingLoading || discardLoading}
                            >
                                Ready For Filing
                            </Button>
                        )}*/}
                    </Box>
                </header>
                <div>
                    <div className="preview-form-layout"
                         style={{
                             pointerEvents: isLoading || filingLoading || discardLoading ? "none" : "auto", // Disable interactions when loading
                             opacity: isLoading || filingLoading || discardLoading ? 0.5 : 1
                         }}
                    >
                        <div className="selected-forms-area">
                            {selectedForm && selectedMatter ? (
                                <PreviewGeneratedFormsSelected
                                    upperSectionProps={upperSectionProps}
                                    setUpperSectionProps={setUpperSectionProps}
                                    lowerSectionProps={lowerSectionProps}
                                    setLowerSectionProps={setLowerSectionProps}
                                    selectedMatter={selectedMatter}
                                    setSelectedMatter={setSelectedMatter}
                                    selectedForm={selectedForm}
                                    setSelectedForm={setSelectedForm}
                                    fetchExistingFormData={fetchExistingFormData}
                                    lowerSectionItems={{
                                        title: "Forms",
                                        selectedItems: formList,
                                        selectedItem: selectedForm
                                    }}
                                    upperSectionItems={{
                                        title: "Docket No.",
                                        selectedDockets: matterList,
                                        selectedItems: matterList.reduce((acc, matter) => {
                                            acc[matter.id] = formList;
                                            return acc;
                                        }, {}),
                                        selectedDocket: selectedMatter,
                                        selectedForm: selectedForm
                                    }}
                                    setDisabledFiling={setDisabledFiling}
                                    checkedDockets={checkedDockets}
                                    setCheckedDockets={setCheckedDockets}
                                    checkedForms={checkedForms}
                                    setCheckedForms={setCheckedForms}
                                />
                            ) : ""}
                        </div>
                        {isLoading ? (
                            <Div
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    minHeight: "60vh",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    ".btn-loader-icon": {
                                        width: "60px",
                                        height: "60px",
                                        border: "5px solid gray",
                                        borderColor: "transparent gray gray gray",
                                        borderRadius: "50%",
                                        animation: "rotate .5s linear infinite"
                                    }
                                }}
                            >
                                <div className="btn-loader-icon"></div>
                            </Div>
                        ) : (filingLoading ? upperSectionProps?.selectedItems?.[selectedMatter] : formList).find(form => form.id === selectedForm)?.isXfa ? (
                            <div className="syncfusion-form-area">
                                <IconButton
                                    sx={{
                                        top: "50%",
                                        transform: "translateY(-50%)"
                                    }}
                                    size="small"
                                    onClick={backHandler}
                                >
                                    <ArrowBackIosNewOutlinedIcon/>
                                </IconButton>
                                {formComponent}
                                <div style={{display: "none"}}>
                                    <PdfFormPreview
                                        formData={formData}
                                        isPreviousFormData={isPreviousFormData}
                                        setPreviousFormData={setPreviousFormData}
                                        setCurrentFormData={setCurrentFormData}
                                    />
                                </div>
                                <IconButton
                                    sx={{
                                        top: "50%",
                                        transform: "translateY(-50%)"
                                    }}
                                    size="small"
                                    onClick={onSaveAndNext}
                                >
                                    <ArrowForwardIosOutlinedIcon/>
                                </IconButton>
                            </div>
                        ) : (
                            <div className="syncfusion-form-area">
                                <IconButton
                                    disabled={disableSaveNext}
                                    onClick={backHandler}
                                    size="small"
                                    sx={{
                                        top: "50%",
                                        transform: "translateY(-50%)"
                                    }}
                                >
                                    <ArrowBackIosNewOutlinedIcon/>
                                </IconButton>
                                <div className="container">
                                    <PdfFormPreview
                                        formData={formData}
                                        isPreviousFormData={isPreviousFormData}
                                        setPreviousFormData={setPreviousFormData}
                                        setCurrentFormData={setCurrentFormData}
                                    />
                                </div>
                                <IconButton
                                    sx={{
                                        transform: "translateY(-50%)",
                                        top: "50%"
                                    }}
                                    size="small"
                                    disabled={disableSaveNext}
                                    onClick={onSaveAndNext}
                                >
                                    <ArrowForwardIosOutlinedIcon/>
                                </IconButton>
                            </div>
                        )}
                        <FormReplaceModal replaceModalOpen={replaceModalOpen} onConfirm={replaceModalOpen?.onConfirm} onCancel={replaceModalOpen?.onCancel} matterName={replaceModalOpen?.matterName} formCode={replaceModalOpen?.formCode}/>
                        <ReadyForFilingModal readyForFilingOpen={readyForFilingOpen} setReadyForFilingOpen={setReadyForFilingOpen} setConfirmFiling={setConfirmFiling}/>
                        <CreatingDraftModal creatingDraft={creatingDraft}/>
                        <LastFormSaveModal lastFormSaveModalOpen={lastFormSaveModalOpen} setLastFormSaveModalOpen={setLastFormSaveModalOpen} setConfirmRedirect={setConfirmRedirect}/>
                    </div>
                </div>
            </Box>
        </div>
    );
};


export default PreviewForms;